<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showCreateUser"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="create"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full"
        >
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Create User</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>

          <transition name="fade">
            <div
              v-if="create_success"
              class="p-1 text-center text-sm w-full bg-green-200"
            >
              {{ create_success }}
            </div>
          </transition>
          <div class="grid grid-cols-2 p-4 gap-3">
            <div class="text-sm">
              <label class="block pb-1">Full Name</label>
              <input
                v-model="info.Fullname"
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
                required
                placeholder="Full Name"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1">Username</label>
              <input
                v-model="info.Username"
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
                required
                placeholder="Username"
              />
            </div>
          </div>
          <div class="text-sm p-4 py-2">
            <label class="block pb-1">Email</label>
            <input
              type="email"
              class="p-2 bg-gray-200 rounded-full w-full disabled border-0.5"
              v-model="info.Email"
            />
          </div>

          <div class="text-sm p-4 py-2">
            <label class="block pb-1">Phone</label>
            <input
              type="tel"
              class="p-2 bg-gray-200 rounded-full w-full disabled border-0.5"
              v-model="info.Phonenumber"
              required
            />
          </div>

          <div class="text-sm p-4 py-2">
            <label class="block pb-1">Role</label>
            <select
              required
              class="p-2 bg-gray-200 rounded-full w-full"
              v-model="info.Role"
            >
              <option v-for="(role, index) in roles" :key="index">
                {{ role }}
              </option>
            </select>
          </div>

          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Create
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
import axios from "axios";
export default {
  name: "CreateUser",
  props: ["showCreateUser"],
  components: { Loader },
  data() {
    return {
      create_error: null,
      loading: false,
      create_success: null,
      roles: ["Administrator", "System Administrator"],
      info: {
        Fullname: "",
        Username: "",
        Email: "",
        Phonenumber: "",
        Role: "",
      },
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
  methods: {
    close() {
      this.$emit("close");
      this.info = {
        Fullname: "",
        Username: "",
        Email: "",
        Phonenumber: "",
        Role: "",
      };
    },
    create() {
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      // Handle the special case of 'System Administrator'
      if (this.info.Role.trim() === "System Administrator") {
        this.info.Role = "SystemAdministrator";
      }

      this.loading = true;
      this.create_error = null;
      this.create_success = null;

      axios
        .post(`user/${this.$ApiVersion}/create`, this.info, options)
        .then((response) => {
          this.loading = false;
          if (response.data.StatusCode === 200) {
            this.create_success = response.data.StatusMessage;
            setTimeout(() => {
              this.create_success = null;
              this.$emit("closeOnSuccess");
            }, 3000);
          } else {
            this.create_error = response.data.StatusMessage;
            setTimeout(() => {
              this.create_error = null;
            }, 3000);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.create_error = error.message;
          setTimeout(() => {
            this.create_error = null;
          }, 3000);
        });
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
